<template>
  <div class="app" id="app">
      <router-view />
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShoppingMall: true
    }
  },
  components: {}
}
</script>
<style lang="stylus">
.app
  height 100vh
</style>
